import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonDirective } from '../../directives/button.directive';
import { InputDirective } from '../../directives/input.directive';
import { SelectDirective } from '../../directives/select.directive';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';

/**
 * Small, dependency-free UI primitives (`appButton`, `appInput`, `appSelect`,
 * `app-loading-spinner`) extracted from `StartupModule` so they can also be
 * imported directly by `FlightSeatMapSharedModule` without recreating the
 * `StartupModule` <-> `ResultsModule` circular dependency (see
 * `flight-seat-map-shared.module.ts`).
 */
const declarationsAndExports = [
  ButtonDirective,
  InputDirective,
  SelectDirective,
  LoadingSpinnerComponent
];

@NgModule({
  imports: [CommonModule],
  declarations: declarationsAndExports,
  exports: declarationsAndExports
})
export class SharedUiModule {}
